/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPGENDER } from './IAPGENDER';
import {
    IAPGENDERFromJSON,
    IAPGENDERFromJSONTyped,
    IAPGENDERToJSON,
} from './IAPGENDER';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';

/**
 * 
 * @export
 * @interface ProposalSummaryIndividualDetails
 */
export interface ProposalSummaryIndividualDetails {
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryIndividualDetails
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryIndividualDetails
     */
    initials?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryIndividualDetails
     */
    surname?: string;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof ProposalSummaryIndividualDetails
     */
    hasSouthAfricanIDNumber?: IAPYESORNO;
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryIndividualDetails
     */
    identityNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryIndividualDetails
     */
    passportNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProposalSummaryIndividualDetails
     */
    dateOfBirth?: Date;
    /**
     * 
     * @type {IAPGENDER}
     * @memberof ProposalSummaryIndividualDetails
     */
    gender?: IAPGENDER;
}

/**
 * Check if a given object implements the ProposalSummaryIndividualDetails interface.
 */
export function instanceOfProposalSummaryIndividualDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProposalSummaryIndividualDetailsFromJSON(json: any): ProposalSummaryIndividualDetails {
    return ProposalSummaryIndividualDetailsFromJSONTyped(json, false);
}

export function ProposalSummaryIndividualDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryIndividualDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': !exists(json, 'FirstName') ? undefined : json['FirstName'],
        'initials': !exists(json, 'Initials') ? undefined : json['Initials'],
        'surname': !exists(json, 'Surname') ? undefined : json['Surname'],
        'hasSouthAfricanIDNumber': !exists(json, 'HasSouthAfricanIDNumber') ? undefined : IAPYESORNOFromJSON(json['HasSouthAfricanIDNumber']),
        'identityNumber': !exists(json, 'IdentityNumber') ? undefined : json['IdentityNumber'],
        'passportNumber': !exists(json, 'PassportNumber') ? undefined : json['PassportNumber'],
        'dateOfBirth': !exists(json, 'DateOfBirth') ? undefined : (new Date(json['DateOfBirth'])),
        'gender': !exists(json, 'Gender') ? undefined : IAPGENDERFromJSON(json['Gender']),
    };
}

export function ProposalSummaryIndividualDetailsToJSON(value?: ProposalSummaryIndividualDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FirstName': value.firstName,
        'Initials': value.initials,
        'Surname': value.surname,
        'HasSouthAfricanIDNumber': IAPYESORNOToJSON(value.hasSouthAfricanIDNumber),
        'IdentityNumber': value.identityNumber,
        'PassportNumber': value.passportNumber,
        'DateOfBirth': value.dateOfBirth === undefined ? undefined : (value.dateOfBirth.toISOString()),
        'Gender': IAPGENDERToJSON(value.gender),
    };
}

